import React, { useContext, useEffect, useState } from "react";
import { useConditions } from "../hooks/use-conditions";
import { useAccount, useClearFilterEvent } from "@yuno/dashboard-container-mfe";
import { useUpdateCheckoutTemplate } from "@yuno/dashboard-api-mfe";
import { useSnackbarContext } from "@yuno/dashboard-container-mfe";
import { ThemeContext } from "./theme-context";
import { useTranslation } from "react-i18next";

export const MainContext = React.createContext(null);

export const MainProvider = ({ children }) => {
  const { customTheme, setUserAction, userAction } = useContext(ThemeContext);
  const { t } = useTranslation();

  const [page, setPage] = useState("CONDITIONS");
  const {
    checkout,
    paymentMethods,
    enrollment,
    isLoading: isLoadingCheckout,
    status: statusCheckout,
    mutateCheckout,
    statusMutateCheckout,
    refetch,
  } = useConditions();

  const { mutate: checkoutTemplateMutation } = useUpdateCheckoutTemplate();
  const account = useAccount();
  const { onOpenSnackbar } = useSnackbarContext();
  const [lists, setLists] = useState({ enrollment: [], paymentMethods: [] });

  useClearFilterEvent(() => {
    setPage("CONDITIONS");
  });

  useEffect(() => {
    if (statusMutateCheckout === "success") {
      onOpenSnackbar(
        t('success'),
        "success",
        "CheckCircle",
        { vertical: "bottom", horizontal: "center" },
        "375px"
      );
    } else if (statusMutateCheckout === "error") {
      onOpenSnackbar(
        t('error'),
        "error",
        "Info",
        { vertical: "bottom", horizontal: "center" },
        "375px"
      );
    }
  }, [statusMutateCheckout]);

  useEffect(() => {
    if (statusCheckout === "success") {
      setLists({ enrollment, paymentMethods });
    }
  }, [statusCheckout]);

  const handlePublish = () => {
    setUserAction(false);
    checkoutTemplateMutation({
      accountCode: account.code,
      template: customTheme,
    });
    let data = [...lists.enrollment, ...lists.paymentMethods];
    data = data.map((el, key) => ({
      is_active: el.is_active,
      payment_method_type: el.payment_method_type,
      order_to_show: key,
    }));

    mutateCheckout({
      checkoutCode: checkout.code,
      paymentMethods: data,
    });
  };

  const handleChange = (type, reordered) => {
    setUserAction(true);
    setLists({
      ...lists,
      [type]: reordered,
    });
  };

  const handleSwitch = (type, checked, data) => {
    setUserAction(true);
    setLists({
      ...lists,
      [type]: lists[type].map((el) => {
        if (el.payment_method_type === data.payment_method_type) {
          el.is_active = checked;
        }
        return el;
      }),
    });
  };

  return (
    <MainContext.Provider
      value={{
        page,
        checkout,
        paymentMethods,
        enrollment,
        isLoadingCheckout,
        statusCheckout,
        lists,
        statusMutateCheckout,
        setLists,
        handleChange,
        handleSwitch,
        setPage,
        handlePublish,
        refetch,
        customTheme,
        userAction,
        setUserAction,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};
